import { useDataFormStore } from "@/stores/form";
import { useDataFormStoreApi } from "@/stores/formSave";

export default {
  setup() {

    const dataForm = useDataFormStore();

    function openWindow() {
        dataForm.detailsDropdown = !dataForm.detailsDropdown
        setTimeout(() => {
          document.querySelector('.result-frames__wrapper').setAttribute("style", "min-height: " + ((dataForm.detailsDropdown || dataForm.cityDropdown) ? document.querySelector("[data-frame='2']").offsetHeight+"px" : "75px"));
        }, 500);
    }
    
    // *** Вкл/Выкл поля с результатами снизу
    const dataFormApi = useDataFormStoreApi();
    return {
      dataForm,
      openWindow,
      dataFormApi,
    };
  },
};
